// Vue
import { Vue, Component, Prop, Inject } from "vue-property-decorator";

// Template
import template from "./template.vue";

// Base Module
import ModuleBase from "#/common/ModuleBase";

// Components
import ModuleWrapper from "#/components/module_wrapper/ModuleWrapper";

@Component({
  mixins: [template],
  components: {
    ModuleWrapper,
  },
})
export class MasonryModule extends ModuleBase {
  private btnMap: any = {
    ["wb-e-btn-1"]: "primary",
    ["wb-e-btn-2"]: "default",
    ["wb-e-btn-3"]: "inverted",
    ["button_outline"]: "outline-secondary",
  };

  public lang: string = "de";

  @Prop({ default: "ErrorWidget" })
  public type!: string;

  public getBackgroundColorFromInstance(instance: object) {
    return "black";
  }

  get elementId() {
    return "mansory-" + this.id;
  }

  public mounted() {
    // @ts-ignore
    this.$redrawVueMasonry(this.elementId);
    document.addEventListener("scroll", this.handleScroll);
  }

  public handleScroll(e: Event) {
    const rect = this.$el.getBoundingClientRect();
    const viewHeight = Math.max(
      document.documentElement.clientHeight,
      window.innerHeight
    );
    if (
      rect.width > 0 ||
      rect.height > 0 ||
      rect.top > 0 ||
      rect.bottom > 0 ||
      rect.left > 0 ||
      rect.right > 0
    ) {
      if (!(rect.bottom < 0 || rect.top - viewHeight >= 0)) {
        // @ts-ignore
        this.$redrawVueMasonry(this.elementId);
      }
    }
  }
}
